import { StyledIcon } from '../Icon.Styled'
import type { IconProps } from '../Icon.Types'

export const GooglePlayBadgeDarkIcon = (props: IconProps) => {
  return (
    <StyledIcon
      width="180"
      height="54"
      viewBox="0 0 180 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <clipPath id="b" clipPathUnits="userSpaceOnUse">
          <path d="M0 60h155V0H0Z" />
        </clipPath>
        <clipPath id="a" clipPathUnits="userSpaceOnUse">
          <path d="M0 0h206.667v80H0Z" />
        </clipPath>
        <clipPath id="c" clipPathUnits="userSpaceOnUse">
          <path d="M-140 50H15v-60h-155Z" />
        </clipPath>
        <clipPath id="d" clipPathUnits="userSpaceOnUse">
          <path d="M-140 10H15v-60h-155Z" />
        </clipPath>
        <clipPath id="e" clipPathUnits="userSpaceOnUse">
          <path d="M-57.419 20.243h155v-60h-155Z" />
        </clipPath>
        <clipPath id="f" clipPathUnits="userSpaceOnUse">
          <path d="M-62.028 17.737h155v-60h-155Z" />
        </clipPath>
        <clipPath id="g" clipPathUnits="userSpaceOnUse">
          <path d="M-65.279 23h155v-60h-155Z" />
        </clipPath>
        <clipPath id="h" clipPathUnits="userSpaceOnUse">
          <path d="M0 60h155V0H0Z" />
        </clipPath>
        <clipPath id="i" clipPathUnits="userSpaceOnUse">
          <path d="M-74.128 23h155v-60h-155Z" />
        </clipPath>
        <clipPath id="j" clipPathUnits="userSpaceOnUse">
          <path d="M-79.78 21.722h155v-60h-155Z" />
        </clipPath>
        <clipPath id="k" clipPathUnits="userSpaceOnUse">
          <path d="M-79.78 21.722h155v-60h-155Z" />
        </clipPath>
        <clipPath id="l" clipPathUnits="userSpaceOnUse">
          <path d="M-85.575 23h155v-60h-155Z" />
        </clipPath>
        <clipPath id="m" clipPathUnits="userSpaceOnUse">
          <path d="M0 60h155V0H0Z" />
        </clipPath>
        <clipPath id="n" clipPathUnits="userSpaceOnUse">
          <path d="M-30.717 29.424h155v-60h-155Z" />
        </clipPath>
        <clipPath id="o" clipPathUnits="userSpaceOnUse">
          <path d="M-41.488 27.5h155v-60h-155Z" />
        </clipPath>
        <clipPath id="p" clipPathUnits="userSpaceOnUse">
          <path d="M-20.07 19.277h155v-60h-155Z" />
        </clipPath>
        <clipPath id="q" clipPathUnits="userSpaceOnUse">
          <path d="M-30.796 30h155v-60h-155Z" />
        </clipPath>
      </defs>
      <path
        d="M0 0h-125c-2.75 0-5 2.25-5 5v30c0 2.75 2.25 5 5 5H0c2.75 0 5-2.25 5-5V5c0-2.75-2.25-5-5-5"
        clipPath="url(#c)"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
        transform="matrix(1.33333 0 0 -1.33333 173.333 53.333)"
      />
      <path
        d="M0 0h-125c-2.75 0-5-2.25-5-5v-30c0-2.75 2.25-5 5-5H0c2.75 0 5 2.25 5 5v30c0 2.75-2.25 5-5 5m0-.8C2.316-.8 4.2-2.684 4.2-5v-30c0-2.316-1.884-4.2-4.2-4.2h-125a4.205 4.205 0 0 0-4.2 4.2v30c0 2.316 1.884 4.2 4.2 4.2z"
        clipPath="url(#d)"
        style={{
          fill: '#a6a6a6',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
        transform="matrix(1.33333 0 0 -1.33333 173.333 0)"
      />
      <path
        d="M0 0c0-.838-.248-1.505-.745-2.003-.565-.592-1.3-.888-2.204-.888-.867 0-1.603.3-2.208.901-.607.6-.909 1.345-.909 2.233 0 .889.302 1.633.909 2.234.605.6 1.341.901 2.208.901.429 0 .841-.084 1.231-.252.391-.168.704-.391.939-.67l-.528-.528c-.397.474-.944.712-1.642.712a2.282 2.282 0 0 1-1.639-.666c-.461-.445-.691-1.021-.691-1.731 0-.709.23-1.286.691-1.73a2.278 2.278 0 0 1 1.639-.666c.67 0 1.228.223 1.676.67.29.291.457.695.502 1.215h-2.178v.721h2.907A2.58 2.58 0 0 0 0 0"
        clipPath="url(#e)"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: '#fff',
          strokeWidth: 0.2,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        transform="matrix(1.33333 0 0 -1.33333 63.225 13.657)"
      />
      <path
        d="M0 0h-2.732v-1.902h2.464v-.721h-2.464v-1.902H0v-.738h-3.503v6H0Z"
        clipPath="url(#f)"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: '#fff',
          strokeWidth: 0.2,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        transform="matrix(1.33333 0 0 -1.33333 69.37 10.316)"
      />
      <path
        d="M0 0h-.771v5.263h-1.676V6h4.123v-.737H0Z"
        clipPath="url(#g)"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: '#fff',
          strokeWidth: 0.2,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        transform="matrix(1.33333 0 0 -1.33333 73.705 17.333)"
      />
      <path
        d="M69.938 43h.771v-6h-.771z"
        clipPath="url(#h)"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: '#fff',
          strokeWidth: 0.2,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        transform="matrix(1.33333 0 0 -1.33333 -13.333 66.667)"
      />
      <path
        d="M0 0h-.771v5.263h-1.676V6h4.123v-.737H0Z"
        clipPath="url(#i)"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: '#fff',
          strokeWidth: 0.2,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        transform="matrix(1.33333 0 0 -1.33333 85.504 17.333)"
      />
      <path
        d="M0 0a2.2 2.2 0 0 1 1.63-.674A2.2 2.2 0 0 1 3.26 0c.444.45.667 1.024.667 1.722s-.223 1.273-.667 1.722c-.444.45-.987.675-1.63.675A2.201 2.201 0 0 1 0 3.444c-.443-.449-.666-1.024-.666-1.722S-.443.45 0 0m3.83-.502c-.59-.607-1.323-.91-2.2-.91-.877 0-1.61.303-2.199.91-.59.606-.884 1.347-.884 2.224 0 .877.294 1.619.884 2.225.589.606 1.322.91 2.199.91.872 0 1.603-.305 2.196-.914.592-.609.888-1.349.888-2.221 0-.877-.295-1.618-.884-2.224"
        clipPath="url(#j)"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
        transform="matrix(1.33333 0 0 -1.33333 93.039 15.63)"
      />
      <path
        d="M0 0a2.2 2.2 0 0 1 1.63-.674A2.2 2.2 0 0 1 3.26 0c.444.45.667 1.024.667 1.722s-.223 1.273-.667 1.722c-.444.45-.987.675-1.63.675A2.201 2.201 0 0 1 0 3.444c-.443-.449-.666-1.024-.666-1.722S-.443.45 0 0Zm3.83-.502c-.59-.607-1.323-.91-2.2-.91-.877 0-1.61.303-2.199.91-.59.606-.884 1.347-.884 2.224 0 .877.294 1.619.884 2.225.589.606 1.322.91 2.199.91.872 0 1.603-.305 2.196-.914.592-.609.888-1.349.888-2.221 0-.877-.295-1.618-.884-2.224Z"
        clipPath="url(#k)"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: 0.2,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        transform="matrix(1.33333 0 0 -1.33333 93.039 15.63)"
      />
      <path
        d="M0 0v6h.938l2.916-4.667h.034l-.034 1.156V6h.772V0h-.805L.77 4.894H.737L.77 3.737V0Z"
        clipPath="url(#l)"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: '#fff',
          strokeWidth: 0.2,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        transform="matrix(1.33333 0 0 -1.33333 100.767 17.333)"
      />
      <path
        d="M116.936 20h1.866v12.501h-1.866zm16.807 7.998-2.139-5.42h-.064l-2.22 5.42h-2.01l3.329-7.575-1.897-4.214h1.945l5.131 11.789zm-10.582-6.578c-.612 0-1.464.305-1.464 1.062 0 .964 1.061 1.334 1.978 1.334.82 0 1.207-.177 1.705-.418a2.262 2.262 0 0 0-2.219-1.978m.225 6.851c-1.351 0-2.751-.595-3.329-1.914l1.656-.691c.354.691 1.013.917 1.705.917.965 0 1.946-.579 1.962-1.609v-.128c-.338.193-1.061.482-1.946.482-1.785 0-3.603-.981-3.603-2.814 0-1.673 1.464-2.751 3.104-2.751 1.255 0 1.947.563 2.381 1.223h.064v-.965h1.801v4.793c0 2.219-1.656 3.457-3.795 3.457m-11.532-1.795H109.2v4.285h2.654c1.395 0 2.187-1.155 2.187-2.142 0-.969-.792-2.143-2.187-2.143m-.048 6.025h-4.471V20h1.865v4.736h2.606c2.068 0 4.101 1.498 4.101 3.883s-2.033 3.882-4.101 3.882M87.425 21.418c-1.289 0-2.368 1.079-2.368 2.561 0 1.498 1.079 2.594 2.368 2.594 1.273 0 2.271-1.096 2.271-2.594 0-1.482-.998-2.561-2.271-2.561m2.143 5.88h-.065c-.419.499-1.224.95-2.239.95-2.127 0-4.076-1.868-4.076-4.269 0-2.384 1.949-4.237 4.076-4.237 1.015 0 1.82.451 2.239.967h.065v-.613c0-1.627-.87-2.497-2.272-2.497-1.144 0-1.853.822-2.143 1.515l-1.627-.677c.467-1.128 1.708-2.513 3.77-2.513 2.191 0 4.044 1.289 4.044 4.43v7.637h-1.772ZM92.629 20h1.869v12.502h-1.869zm4.623 4.124c-.048 1.643 1.273 2.481 2.223 2.481.742 0 1.37-.37 1.579-.902zm5.8 1.418c-.354.95-1.434 2.706-3.641 2.706-2.191 0-4.011-1.723-4.011-4.253 0-2.384 1.804-4.253 4.22-4.253 1.95 0 3.078 1.192 3.545 1.885l-1.45.967c-.483-.709-1.144-1.176-2.095-1.176-.95 0-1.627.435-2.062 1.288l5.687 2.353zm-45.308 1.401v-1.804h4.317c-.129-1.015-.467-1.756-.982-2.271-.629-.629-1.612-1.322-3.335-1.322-2.659 0-4.737 2.143-4.737 4.801 0 2.659 2.078 4.801 4.737 4.801 1.434 0 2.481-.564 3.254-1.289l1.273 1.273c-1.08 1.031-2.513 1.821-4.527 1.821-3.641 0-6.702-2.965-6.702-6.606s3.061-6.605 6.702-6.605c1.965 0 3.447.645 4.607 1.853 1.193 1.192 1.563 2.867 1.563 4.221 0 .419-.032.805-.097 1.127zm11.079-5.525c-1.289 0-2.401 1.063-2.401 2.577 0 1.531 1.112 2.578 2.401 2.578 1.288 0 2.4-1.047 2.4-2.578 0-1.514-1.112-2.577-2.4-2.577m0 6.83c-2.353 0-4.27-1.788-4.27-4.253 0-2.449 1.917-4.253 4.27-4.253 2.352 0 4.269 1.804 4.269 4.253 0 2.465-1.917 4.253-4.269 4.253m9.313-6.83c-1.289 0-2.401 1.063-2.401 2.577 0 1.531 1.112 2.578 2.401 2.578 1.289 0 2.4-1.047 2.4-2.578 0-1.514-1.111-2.577-2.4-2.577m0 6.83c-2.352 0-4.269-1.788-4.269-4.253 0-2.449 1.917-4.253 4.269-4.253 2.352 0 4.269 1.804 4.269 4.253 0 2.465-1.917 4.253-4.269 4.253"
        clipPath="url(#m)"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
        transform="matrix(1.33333 0 0 -1.33333 -13.333 66.667)"
      />
      <path
        d="m0 0-10.647-11.3.002-.007a2.874 2.874 0 0 1 4.236-1.734l.034.02L5.609-6.106z"
        clipPath="url(#n)"
        style={{
          fill: '#ea4335',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
        transform="matrix(1.33333 0 0 -1.33333 27.623 25.899)"
      />
      <path
        d="m0 0-.01.007-5.174 2.999-5.829-5.187 5.85-5.848L-.017-5.06A2.88 2.88 0 0 1 0 0"
        clipPath="url(#o)"
        style={{
          fill: '#fbbc04',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
        transform="matrix(1.33333 0 0 -1.33333 41.984 23.333)"
      />
      <path
        d="M0 0a2.823 2.823 0 0 1-.098-.74v-19.968c0-.256.034-.504.099-.739l11.012 11.011z"
        clipPath="url(#p)"
        style={{
          fill: '#4285f4',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
        transform="matrix(1.33333 0 0 -1.33333 13.427 12.37)"
      />
      <path
        d="m0 0 5.51 5.509-11.97 6.94a2.878 2.878 0 0 1-4.265-1.722l-.001-.003z"
        clipPath="url(#q)"
        style={{
          fill: '#34a853',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
        transform="matrix(1.33333 0 0 -1.33333 27.728 26.668)"
      />
    </StyledIcon>
  )
}
